export default "__VITE_ASSET__BabwqBbe__"